import { Injectable } from '@angular/core';
import { Config, Events } from 'ionic-angular';

@Injectable()
export class BulkSms {

  public numbers: Array<any> = [];

  constructor(
    public events: Events,
    public config: Config
  ) {};

  addNumber(tel: string): void {
    if (this.numbers.indexOf(tel) === -1) {
      this.numbers.push(tel);
    }
  }

  removeNumber(tel: string): void {
    const i = this.numbers.indexOf(tel);
    if (i !== -1) {
      this.numbers.splice(i, 1);
    }
  }

  check(tel: string): boolean {
    return this.numbers.indexOf(tel) !== -1;
  }
}


// WEBPACK FOOTER //
// ./src/providers/bulk.service.ts